import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Injectable({
  providedIn: 'root',
})
export class MettingService {
  private mettingList = new BehaviorSubject<any[]>([]);
  meets$ = this.mettingList.asObservable(); // Expose tasks as observable

  constructor(
    private localStorage: LocalStorageService
  ) {}

  setMettings(mettings: any[]) {
    this.mettingList.next(mettings);
  }

  addMeet(meeting: any) {

    console.log("meeting12345", meeting);
   
    let newMeetObj:any = {
        name: this.localStorage.getProfileName(),
        date:  moment(new Date()).format('DD/MM/YYYY HH:mm'),
        desc: `Meeting Title: ${meeting?.meeting_title} - Meeting Description: ${meeting?.meeting_desc} - Meeting Link: ${meeting?.meeting_link} - Meeting Date: ${meeting?.startDate} - Meeting Time: ${meeting?.meetingTime}`,
        id: meeting?.id,
        restData: meeting
    }

    this.mettingList.next([newMeetObj, ...this.mettingList.value]);
  }

}
